import * as React from "react";
import { createStyles, Grid, Theme, withStyles } from "@material-ui/core";
import Logo from "./Logo";
import CompleteOrderShipmentSection from "./complete_order_shipment/CompleteOrderShipmentSection";

const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      marginLeft: spacing(16),
      marginRight: spacing(16),
    },
  });

const Page = (props: any) => {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <Grid container spacing={10} justifyContent="center" alignItems="stretch">
        <Logo />
        <CompleteOrderShipmentSection />
      </Grid>
    </div>
  );
};

export default withStyles(styles)(Page);
